<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <!-- 顶部搜索区域 -->
    <div class="global-mb16">
      <y-tip class="global-mb16">
        <div>
          1.黑名单为会员级别，即全渠道会员ID下绑定的所有平台账号都遵循黑名单逻辑。
        </div>
        <div>
          2.加入黑名单的会员：不会进行积分、成长值增加、不会进行等级升级。
        </div>
        <div>3.加入黑名单会员将无法消费积分、等级升级。</div>
        <div>
          4.加入黑名单的会员若存在积分到期、等级过期或成长值过期，则会进行过期处理。
        </div>
        <div>
          5.黑名单中的会员允许对会员进行等级、积分和成长值的手工降级和手工扣减，但是无法操作升级和增加。
        </div>
        <div>
          6.当会员被添加到黑名单产生了退款订单，不影响系统从会员的可用积分中扣减。
        </div>
        <div>
          7.操作【移除】后，可将当前会员从会员黑名单中移除，但在黑名单期间产生的订单不影响等级、积分和成长值不支持重算更新，如需调整请手动操作。
        </div>
      </y-tip>
      <y-form :formInfo="formInfo" @search="search"> </y-form>
    </div>
    <!-- 手动添加 -->
    <div class="global-mb16">
      <y-button @click="openAddDialog">手动添加</y-button>
    </div>
    <!-- 活动列表：table 单独放在 flex-1 容器里，才能正确撑满并出现内部滚动条 -->
    <div class="global-felx-1">
      <y-table
        :tableData="tableData"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: total,
        }"
        @handlePage="handlePage"
      >
        <template #memberId="scope">
          {{ scope.row.memberId || scope.row.platformUserId }}
        </template>
        <template #changeType="scope">
          手动添加
        </template>
        <template #operation="scope">
          <y-button type="blueText" @click="handleRemove(scope.row)">移除</y-button>
        </template>
      </y-table>
    </div>

    <!-- 移除黑名单二次确认 -->
    <y-dialog
      title="移除黑名单"
      :visible.sync="removeVisible"
      width="580px"
      :draggable="false"
      @close="removeVisible = false"
    >
      <div class="remove-tip">
        移除会员黑名单后，会员加入黑名单期间未发放的积分、成长值不会再回补至会员账户，后续等级计算时无法自动剔除加入黑名单期间的订单指标。
      </div>
      <template slot="footer">
        <y-button @click="removeVisible = false">取消</y-button>
        <y-button type="blue" :loading="removeLoading" @click="confirmRemove"
          >确定</y-button
        >
      </template>
    </y-dialog>

    <!-- 手动添加黑名单会员 -->
    <blackListAddDialog
      v-if="addDialogShow"
      :isShowDialog="addDialogShow"
      @close="addDialogShow = false"
      @success="addSuccess"
    ></blackListAddDialog>
  </div>
</template>

<script>
import { getMemberBlacklistList, removeMemberBlacklist } from "@/api/memberMessageSystem";
import blackListAddDialog from "./compontents/blackListAddDialog.vue";
export default {
  name: "gradeRecord",
  components: { blackListAddDialog },
  data() {
    return {
      total: 0,
      formDataList: {
        memberId: "", //全渠道会员ID
        // 页码
        pageNum: 1,
        pageSize: 10,
      },
      // 变更来源
      changeSourceList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "手动导入会员",
        },
        {
          value: 2,
          label: "会员正常升级",
        },
        {
          value: 3,
          label: "会员等级失效降级",
        },
        {
          value: 4,
          label: "会员等级失效保级",
        },
        {
          value: 5,
          label: "手动调整",
        },
      ],

      talbeLoading: false,
      tableData: [],
      // 移除黑名单确认弹窗
      removeVisible: false,
      removeLoading: false,
      removeRow: {},
      // 手动添加弹窗
      addDialogShow: false,

      formInfo: [
        {
          label: "全渠道会员ID：",
          prop: "memberId",
          type: "Input",
          placeholder: "请输入",
        }
      ],
      tableInfo: [
        {
          prop: "memberId",
          label: "全渠道会员ID",
          slot: "memberId",
        },
        {
          prop: "changeType",
          label: "添加类型",
          slot: "changeType",
        },
        {
          prop: "remark",
          label: "备注/添加原因",
          showOverflowTooltip: true,
        },
        {
          prop: "createPerson",
          label: "创建人",
        },
        {
          prop: "createTime",
          label: "创建时间",
        },
        {
          prop: "operation",
          label: "操作",
          slot: "operation",
        },
      ],
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员信息管理", "等级变更记录");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {
    // 获取等级变更列表
    this.getMemberBlacklistListFn();
  },
  methods: {
    search(obj) {
      for (const key in obj) {
        this.formDataList[key] = obj[key];
      }
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getMemberBlacklistListFn();
    },
    // 获取会员黑名单列表
    getMemberBlacklistListFn() {
      this.talbeLoading = true;
      getMemberBlacklistList({
        ...this.formDataList,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      })
        .then((res) => {
          this.talbeLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.total = res.data.pageInfo.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      this.getMemberBlacklistListFn();
    },
    // 分页
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.getMemberBlacklistListFn();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.getMemberBlacklistListFn();
    },
    getClean() {
      this.formDataList = {
        memberId: "", //全渠道会员ID
        // 页码
        pageNum: 1,
        pageSize: 10,
      };
      this.getMemberBlacklistListFn();
    },
    // 点击「手动添加」：打开手动添加弹窗
    openAddDialog() {
      this.addDialogShow = true;
    },
    // 添加成功：关弹窗并刷新列表
    addSuccess() {
      this.addDialogShow = false;
      this.getMemberBlacklistListFn();
    },
    // 点击「移除」：打开二次确认弹窗
    handleRemove(row) {
      this.removeRow = row || {};
      this.removeVisible = true;
    },
    // 确认移除
    confirmRemove() {
      this.removeLoading = true;
      // 黑名单ID按路径参数传：/memberBlacklist/remove/{id}
      removeMemberBlacklist(this.removeRow.id).then((res) => {
        if (res.code == 200) {
          this.$message.success("移除成功");
          this.removeLoading = false;
          this.removeVisible = false;
          this.getMemberBlacklistListFn();
        } else {
          this.$message.error(res.message);
          this.removeLoading = false;
        }
      }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
// 移除黑名单弹窗正文：居中展示提示文案
.remove-tip {
  max-width: 620px;
  margin: 0 auto;
  padding: 32px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
</style>